import { GET_ALL_PAUSAS, GET_SPECIFIC_PAUSA } from './mutation-types'

export default {
  [GET_ALL_PAUSAS]: (state, pausas) => {
    state.pausas = pausas
  },
  [GET_SPECIFIC_PAUSA]: (state, pausa) => {
    state.pausa = pausa
  },
}
